import {
  type Translationtype,
  convertDate,
  findEventTypeOption,
  montserrat,
  getServicePackageName,
} from "utils";
import { eventTypeOptions } from "../../constants";
import { useLocale } from "next-intl";

interface ISimpleSelectedReservationProps {
  selectedReservation: any;
  t: Translationtype;
}

export function SimpleSelectedReservation({
  selectedReservation,
  t,
}: ISimpleSelectedReservationProps) {
  const locale = useLocale();
  return (
    <div className="flex flex-col gap-3 my-5 w-fit mx-auto mb-10">
      <div className="flex flex-col bg-[#d9c1a7] rounded-full px-4 py-2">
        <h2
          className={`${montserrat.className} text-lg text-[#1e293b] font-semibold text-center`}
        >
{selectedReservation.title
  ? selectedReservation.title
  : selectedReservation.eventType !== -1
    ? t(
        `Options.event.${findEventTypeOption(selectedReservation.eventType, eventTypeOptions)}` as any
      )
    : ""}
        </h2>
        <span
          className={`${montserrat.className} block text-[#1e293b] text-center text-base whitespace-nowrap`}
        >
          {`${convertDate(selectedReservation.eventStartTime, "utcToLocaleDate", locale)} - ${convertDate(
            selectedReservation.eventEndTime,
            "utcToLocaleDate",
            locale
          )}`}
        </span>
      </div>
      <p className="text-[#1e293b] border-[#1e293b] border-2 rounded-full py-2 px-4 text-center text-lg w-fit mx-auto">
        {getServicePackageName(selectedReservation.servicePackage, t)}
      </p>
    </div>
  );
}
